import React from 'react';
import { motion, HTMLMotionProps } from 'framer-motion';
interface GlassCardProps extends HTMLMotionProps<'div'> {
  children: ReactNode;
  className?: string;
  hoverEffect?: boolean;
}
export function GlassCard({
  children,
  className = '',
  hoverEffect = false,
  ...props
}: GlassCardProps) {
  return <motion.div className={`relative overflow-hidden rounded-2xl border border-white/10 bg-white/5 backdrop-blur-xl shadow-xl ${className}`} whileHover={hoverEffect ? {
    scale: 1.02,
    y: -5,
    boxShadow: '0 20px 40px rgba(0,0,0,0.2)'
  } : undefined} transition={{
    type: 'spring',
    stiffness: 300,
    damping: 20
  }} {...props} data-id="element-130">
      {/* Subtle shine effect overlay */}
      <div className="absolute inset-0 bg-gradient-to-br from-white/10 to-transparent opacity-50 pointer-events-none" data-id="element-131" />
      <div className="relative z-10" data-id="element-132">{children}</div>
    </motion.div>;
}